export const scadenzaStatusMap = {
  da_pagare: {
    label: 'Da pagare',
    color: 'warning'
  },
  pagata: {
    label: 'Pagata',
    color: 'success'
  },
  pagata_in_ritardo: {
    label: 'Pagata in ritardo',
    color: 'error'
  },
  scaduta: {
    label: 'Scaduta',
    color: 'error'
  },
    da_incassare: {
      label: 'Da incassare',
      color: 'success'
    }
};